import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {
  ApiUserMetadata,
  DepartmentsEnum,
  IndustriesEnum,
  serializeUserMetadata,
  UseCasesEnum,
  UserMetadataModel,
} from '../../../models/api/userMetadataModel';
import {putApiAsync} from '../../../services/http/http';
import {ThunkAction, ThunkAsyncAction} from '../../appThunk';
import {getUser} from '../teammates/teammatesSelectors';
import {getUserMetadata} from '../userMetadata/userMetadataSelectors';

/*
 * Action types.
 */

export enum UserMetadataActionsEnum {
  USER_METADATA_UPDATED = '@@data/userMetadata/USER_METADATA_UPDATED',
}

/*
 * Types.
 */

export interface UserMetadataUpdatedAction extends ActionWithPayload<UserMetadataModel> {
  type: UserMetadataActionsEnum.USER_METADATA_UPDATED;
}

/*
 * Action creators.
 */

export function updateIndustryMetadataAction(newValue: IndustriesEnum): ThunkAction {
  return saveUserMetadataAction({industry: newValue});
}

export function updateDepartmentMetadataAction(newValue: DepartmentsEnum): ThunkAction {
  return saveUserMetadataAction({department: newValue});
}

export function updateUseCasesMetadataAction(newValue: ReadonlyArray<UseCasesEnum>): ThunkAction {
  return saveUserMetadataAction({useCases: newValue});
}

/*
 * Base actions.
 */

export function saveUserMetadataAction(userMetadataUpdate: Partial<UserMetadataModel>): ThunkAsyncAction {
  return async (dispatch, getState) => {
    const state = getState();

    const user = getUser(state);
    const metadata = getUserMetadata(state);

    const body = serializeUserMetadata({
      ...metadata,
      ...userMetadataUpdate,
    });

    const result = await putApiAsync(ApiUserMetadata, user.url, body);

    dispatch(updateUserMetadataAction(result));
  };
}

export function updateUserMetadataAction(userMetadata: UserMetadataModel): UserMetadataUpdatedAction {
  return {
    payload: userMetadata,
    type: UserMetadataActionsEnum.USER_METADATA_UPDATED,
  };
}

/*
 * Union type.
 */

export type UserMetadataAction = UserMetadataUpdatedAction;
